import { toast } from "react-toastify";
import { MasterDataConstants } from "../constants";
import { masterDataService } from "../services";

//createMasterData
const createMasterData = (masterData) => {
    const request = (masterData) => {
        return { type: MasterDataConstants.CREATEMASTERDATA_REQUEST, masterData };
    };
    const success = (data) => {
        return { type: MasterDataConstants.CREATEMASTERDATA_SUCCESS, data };
    };
    const failure = (error) => {
        return { type: MasterDataConstants.CREATEMASTERDATA_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request(masterData));
        return masterDataService.createMasterData(masterData).then(
            (data) => {
                toast.success("Master data created");
                dispatch(success(data));
                return data;
            },
            (error) => {
                toast.error(error.toString());
                dispatch(failure(error.toString()));
                return false;
            }
        );
    };
};

//updateMasterData
const updateMasterData = (masterData, id) => {
    const request = (masterData) => {
        return { type: MasterDataConstants.UPDATEMASTERDATA_REQUEST, masterData };
    };
    const success = (data) => {
        return { type: MasterDataConstants.UPDATEMASTERDATA_SUCCESS, data };
    };
    const failure = (error) => {
        return { type: MasterDataConstants.UPDATEMASTERDATA_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request(masterData));
        return masterDataService.updateMasterData(masterData, id).then(
            (data) => {
                toast.success("Master data updated");
                dispatch(success(data));
                return data;
            },
            (error) => {
                toast.error(error.toString());
                dispatch(failure(error.toString()));
                return false;
            }
        );
    };
};

//department
const getDepartments = (query) => {
    const request = () => {
        return { type: MasterDataConstants.GETDEPARTMENT_REQUEST };
    };
    const success = (department) => {
        return { type: MasterDataConstants.GETDEPARTMENT_SUCCESS, department };
    };
    const failure = (error) => {
        return { type: MasterDataConstants.GETDEPARTMENT_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request());

        masterDataService.getDepartments(query).then(
            (department) => {
                dispatch(success(department));
            },
            (error) => {
                dispatch(failure(error.toString()));
            }
        );
    };
};

//getdesignation by department
const getDesignationBydepartment = (id,query) => {
    const request = (id) => {
        return { type: MasterDataConstants.GETDEPARTMENTBYDESIGNATION_REQUEST, id };
    };
    const success = (designation) => {
        return { type: MasterDataConstants.GETDEPARTMENTBYDESIGNATION_SUCCESS, designation };
    };
    const failure = (error) => {
        return { type: MasterDataConstants.GETDEPARTMENTBYDESIGNATION_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request(id));

        masterDataService.getDesignationBydepartment(id,query).then(
            (designation) => {
                dispatch(success(designation));
            },
            (error) => {
                dispatch(failure(error.toString()));
            }
        );
    };
};



//skills
const getSkills = () => {
    const request = () => {
        return { type: MasterDataConstants.GETSKILLS_REQUEST };
    };
    const success = (skills) => {
        return { type: MasterDataConstants.GETSKILLS_SUCCESS, skills };
    };
    const failure = (error) => {
        return { type: MasterDataConstants.GETSKILLS_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request());

        masterDataService.getSkills().then(
            (skills) => {
                dispatch(success(skills));
            },
            (error) => {
                dispatch(failure(error.toString()));
            }
        );
    };
};

//deleteMaterData
const deleteMasterData = (id, query) => {
    const request = (id) => {
        return { type: MasterDataConstants.DELETEMASTERDATA_REQUEST, id };
    };
    const success = (data) => {
        return { type: MasterDataConstants.DELETEMASTERDATA_SUCCESS, data };
    };
    const failure = (error) => {
        return { type: MasterDataConstants.DELETEMASTERDATA_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request());

        masterDataService.deleteMasterData(id, query).then(
            (data) => {
                toast.success("Record deleted");
                dispatch(success(data));
            },
            (error) => {
                dispatch(failure(error.toString()));
            }
        );
    };
};

//deleteDepartment
const deleteDepartment = (id) => {
    const request = (id) => {
        return { type: MasterDataConstants.DELETEDEPARTMENT_REQUEST, id };
    };
    const success = (data) => {
        return { type: MasterDataConstants.DELETEDEPARTMENT_SUCCESS, data };
    };
    const failure = (error) => {
        return { type: MasterDataConstants.DELETEDEPARTMENT_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request());

        masterDataService.deleteDepartment(id).then(
            (data) => {
                toast.success("Department deleted");
                dispatch(success(data));
            },
            (error) => {
                dispatch(failure(error.toString()));
            }
        );
    };
};

//dropdown designation
const getDesignation = (id) => {
    const request = (id) => {
        return { type: MasterDataConstants.GETDESIGNATION_REQUEST, id };
    };
    const success = (designation) => {
        return { type: MasterDataConstants.GETDESIGNATION_SUCCESS, designation };
    };
    const failure = (error) => {
        return { type: MasterDataConstants.GETDESIGNATION_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request(id));

        masterDataService.getDesignationBydepartment(id).then(
            (designation) => {
                dispatch(success(designation));
            },
            (error) => {
                dispatch(failure(error.toString()));
            }
        );
    };
};


export const masterDataActions = {
    getDepartments,
    getDesignationBydepartment,
    getSkills,
    createMasterData,
    updateMasterData,
    deleteMasterData,
    deleteDepartment,
    getDesignation
};